import React from 'react';
import { ShimmerComponent } from '@zydalabs/storefront-components';
import dynamic from 'next/dynamic';

import { StyledPageWrapper } from './styles';

const StoreFrontHeaderComponent = dynamic(() => import('common/components/StoreFrontHeader'));

const EstimatedTimeLoading = ({ headerTitle }: { headerTitle: string }) => (
  <StyledPageWrapper>
    <StoreFrontHeaderComponent title={headerTitle} />
    <ShimmerComponent.ShimmerEffect style={{ display: 'flex', flexDirection: 'column', margin: '10px' }}>
      {Array.from([...Array(2)].keys()).map(num => (
        <ShimmerComponent.NoAnimationBox style={{ alignItems: 'center' }} key={num}>
          <ShimmerComponent.Circle radius={20} m={2} />
          <ShimmerComponent.Rect height={20} />
        </ShimmerComponent.NoAnimationBox>
      ))}
    </ShimmerComponent.ShimmerEffect>
  </StyledPageWrapper>
);

export default EstimatedTimeLoading;
